import { Address } from '@legacy/types/Address'
import { BankDetail } from '@legacy/types/BankDetail'
import { Country } from '@legacy/types/Country'
import { IPartner, PartnerKind } from '@legacy/types/Partner'

/**
 * Represents a Partner record. Attributes are specific to what is required to
 * represent the partner for the authenticated user to aid with display and
 * requests, rather than a partner record we are interacting with
 */
class Partner {
  readonly id: string
  readonly entityName: string
  readonly shortName?: string
  readonly phoneNumber?: string | null
  readonly corporateAddress?: Address | null
  readonly billingAddress?: Address | null
  readonly kind: PartnerKind
  readonly financialServicesGuideUrl: string | null
  readonly businessNumber: string | null
  readonly logoImageUrl: string | null | undefined
  readonly bankDetail?: BankDetail | null
  readonly canDeferPayment?: boolean
  readonly status?: string
  readonly xeroContactId?: string
  readonly countryId: string
  readonly country: Country
  readonly metaData?: any

  constructor({
    id,
    entityName,
    shortName,
    corporateAddress,
    billingAddress,
    kind,
    phoneNumber,
    financialServicesGuideUrl,
    businessNumber,
    logoImageUrl,
    bankDetail,
    canDeferPayment,
    status,
    xeroContactId,
    countryId,
    country,
    metaData,
  }: IPartner) {
    this.id = id
    this.entityName = entityName
    this.shortName = shortName
    this.corporateAddress = corporateAddress
    this.billingAddress = billingAddress
    this.kind = kind
    this.phoneNumber = phoneNumber
    this.financialServicesGuideUrl = financialServicesGuideUrl
    this.businessNumber = businessNumber
    this.logoImageUrl = logoImageUrl
    this.bankDetail = bankDetail
    this.canDeferPayment = canDeferPayment
    this.status = status
    this.xeroContactId = xeroContactId
    this.countryId = countryId
    this.country = country
    this.metaData = metaData
  }

  get isBroker() {
    return this.kind === 'broker'
  }

  get isAffiliate() {
    return this.kind === 'affiliate'
  }

  get kindLabel() {
    if (this.isBroker) return 'Brokerage'
    if (this.isAffiliate) return 'Affiliate'

    return this.kind
  }
}

export default Partner
